module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.314210a4.woff2";